import { CustomEase } from 'gsap/dist/CustomEase'

export const EaseBase = CustomEase.create('easeBase', '0.2, 0.8, 0.2, 1')
export const EaseInOut = CustomEase.create('easeInOut', '0.8, 0.14, 0.14, 0.8')
